import { render, staticRenderFns } from "./plantlist.vue?vue&type=template&id=2b7ea2f2&scoped=true"
import script from "./plantlist.vue?vue&type=script&lang=js"
export * from "./plantlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7ea2f2",
  null
  
)

export default component.exports